module.exports = __webpack_public_path__ + "static/PayFit-dce03c9bd3327d3b7292a4d804d5d531.jpg";